export default "__VITE_ASSET__D07ZEc11__"